export default __webpack_public_path__ + "static/media/catalog-24dp.ea4eb7e7.svg";